import { render } from "./filtersBox.vue?vue&type=template&id=71e663ac&ts=true"
import script from "./filtersBox.vue?vue&type=script&lang=ts"
export * from "./filtersBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__